<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import { handleAlert } from "@/components/UtilsIf";
import { handleConfirm } from "@/utils/UtilsIf";

export default {
  name: "teamPerformancePersonDetail",
  components: { breadcrumbs },
  provide() {
    return {
      modalData: this.modalData
    };
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      form: {},
      form1: {},
      form2: {},
      form3: {},
      form4: {},
      modalData: {},
      multipleSelection: [],
      data: [
        {
          id: 1,
          label: "一级 1",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              children: [
                {
                  id: 9,
                  label: "三级 1-1-1"
                },
                {
                  id: 10,
                  label: "三级 1-1-2"
                }
              ]
            }
          ]
        },
        {
          id: 2,
          label: "一级 2",
          children: [
            {
              id: 5,
              label: "二级 2-1"
            },
            {
              id: 6,
              label: "二级 2-2"
            }
          ]
        },
        {
          id: 3,
          label: "一级 3",
          children: [
            {
              id: 7,
              label: "二级 3-1"
            },
            {
              id: 8,
              label: "二级 3-2"
            }
          ]
        }
      ],
      defaultProps: {
        children: "children",
        label: "label"
      },
      selectActive: 1,
      selectArr: [
        {
          id: 1,
          name: "员工权限"
        },
        {
          id: 2,
          name: "绩效提成"
        },
        {
          id: 3,
          name: "客户信息"
        },
        {
          id: 4,
          name: "充值统计"
        }
      ]
    };
  },
  methods: {
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    selectTypeChange(v) {
      this.selectActive = v.id;
    },
    search4() {
      this.$refs.customTable4.search();
    },
    reset4() {
      this.$refs.customTable4.search();
    },
    reset3() {
      this.$refs.customTable3.search();
    },
    reset2() {},
    reset1() {},
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * 转移
     */
    transfer() {
      // if (this.multipleSelection.length !== 1) {
      //   handleAlert("请选择一位客户", "error");
      //   return;
      // }
      Object.assign(this.modalData, this.multipleSelection[0] || {});
      this.$refs.customerTransferModal.open("客户转移");
    },
    submit1() {},
    submit2() {},
    cancel1() {},
    cancel2() {},
    exportTable() {
      handleConfirm("确认导出吗?", "info")
        .then(() => {
          handleAlert("导出成功", "success");
          // this.exportChangeNumVisible = false;
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = URL.createObjectURL(res);
          link.setAttribute(
            "download",
            `消费订单(${this.exportForm.limitStart}-${this.exportForm.limitEnd}).xls`
          );
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(() => {
          return;
        });
    }
  }
};
</script>

<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.back()"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <el-descriptions border :column="3">
      <el-descriptions-item label="员工姓名"
        >{{ form.userName }}
      </el-descriptions-item>
      <el-descriptions-item label="员工电话"
        >{{ form.userPhone }}
      </el-descriptions-item>
      <el-descriptions-item label="员工角色"
        >{{ form.identityCard }}
      </el-descriptions-item>
    </el-descriptions>
    <div class="flex aic jcsb mgt-10">
      <div class="selectBox">
        <div
          :class="selectActive === v.id ? 'selectActive' : 'select'"
          v-for="v in selectArr"
          :key="v.id"
          @click="selectTypeChange(v)"
        >
          {{ v.name }}
        </div>
      </div>
    </div>
    <el-card shadow="never" class="mgt-40">
      <template v-if="selectActive === 1">
        <!-- 整体表单  -->
        <el-form class="mgt-10" ref="form1" :model="form1" label-width="100px">
          <el-form-item label="功能权限" prop="userName">
            <el-card shadow="never">
              <el-tree
                :data="data"
                show-checkbox
                node-key="id"
                :default-expanded-keys="[2, 3]"
                :default-checked-keys="[5]"
                :props="defaultProps"
              >
              </el-tree
            ></el-card>
          </el-form-item>
          <el-form-item
            label="数据权限"
            prop="userPhone"
            :rules="[{ required: true, trigger: 'blur' }]"
          >
            <el-card shadow="never">
              <el-radio-group v-model="form1.awardWay">
                <el-radio :label="0">全部数据</el-radio>
                <el-radio :label="1">所在团队数据</el-radio>
                <el-radio :label="2">个人数据</el-radio>
              </el-radio-group>
            </el-card>
          </el-form-item>
          <el-form-item>
            <el-button @click="cancel1">取消</el-button>
            <el-button type="primary" @click="submit1">
              确定
            </el-button>
          </el-form-item>
        </el-form>
      </template>
      <template v-else-if="selectActive === 2">
        <!-- 整体表单  -->
        <el-form class="mgt-10" ref="form2" :model="form2" label-width="160px">
          <el-form-item
            label="个人绩效比例"
            prop="userName"
            :rules="[
              {
                required: true,
                message: '请输入个人绩效比例',
                trigger: 'blur'
              }
            ]"
          >
            <el-input-number
              v-model="form2.userName"
              placeholder="请输入个人绩效比例"
            ></el-input-number>
            %
          </el-form-item>
          <el-form-item
            label="个人绩效比例范围"
            prop="userPhone"
            :rules="[{ required: true, trigger: 'blur' }]"
          >
            <div class="flex">
              <el-input-number
                v-model="form2.userPhone"
                placeholder="请输入个人绩效比列范围"
              ></el-input-number>
              &nbsp;&nbsp;%&nbsp;至&nbsp;&nbsp;
              <el-input-number
                v-model="form2.userPhone"
                placeholder="请输入个人绩效比列范围"
              ></el-input-number>
              %
            </div>
            <div style="color: var(--danger)">个人绩效可设置比例范围</div>
          </el-form-item>
          <el-form-item
            label="团队绩效比例"
            prop="userName"
            :rules="[
              {
                required: true,
                message: '请输入团队绩效比例',
                trigger: 'blur'
              }
            ]"
          >
            <el-input-number
              v-model="form2.userName"
              placeholder="请输入团队绩效比例"
            ></el-input-number>
            %
          </el-form-item>
          <el-form-item
            label="团队绩效比例范围"
            prop="userPhone"
            :rules="[{ required: true, trigger: 'blur' }]"
          >
            <div class="flex">
              <el-input-number
                v-model="form2.userPhone"
                placeholder="请输入团队绩效比列范围"
              ></el-input-number>
              &nbsp;&nbsp;%&nbsp;至&nbsp;&nbsp;
              <el-input-number
                v-model="form2.userPhone"
                placeholder="请输入团队绩效比列范围"
              ></el-input-number>
              %
            </div>
            <div style="color: var(--danger)">团队绩效可设置比例范围</div>
          </el-form-item>
          <el-form-item label="开卡激励" prop="awardWay">
            <el-radio-group v-model="form2.awardWay">
              <el-radio :label="0">开启</el-radio>
              <el-radio :label="1">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="奖励金额"
            prop="userName"
            :rules="[
              {
                required: true,
                message: '请输入奖励金额',
                trigger: 'blur'
              }
            ]"
          >
            <el-input-number
              v-model="form2.userName"
              placeholder="请输入奖励金额"
            ></el-input-number>
            %
          </el-form-item>
          <el-form-item
            label="奖励金额范围"
            prop="userPhone"
            :rules="[{ required: true, trigger: 'blur' }]"
          >
            <div class="flex">
              <el-input-number
                v-model="form2.userPhone"
                placeholder="请输入奖励金额范围"
              ></el-input-number>
              &nbsp;&nbsp;%&nbsp;至&nbsp;&nbsp;
              <el-input-number
                v-model="form2.userPhone"
                placeholder="请输入奖励金额范围"
              ></el-input-number>
              %
            </div>
            <div style="color: var(--danger)">奖励金额可设置范围</div>
          </el-form-item>
          <el-form-item>
            <el-button @click="cancel2">取消</el-button>
            <el-button type="primary" @click="submit2">
              确定
            </el-button>
          </el-form-item>
        </el-form>
      </template>
      <template v-else-if="selectActive === 3">
        <div class="flex aic mgb-10">
          <span class="mgr-10">客户总数：</span>
          <el-button type="primary" @click="transfer">转移 </el-button>
        </div>
        <customTable
          ref="customTable3"
          :api="undefined"
          :params="form"
          :isMounted="false"
          @selection-change="handleSelectionChange"
        >
          <template #columns>
            <el-table-column
              type="index"
              :index="indexMethod"
              label="序号"
              width="50"
              fixed="left"
            >
            </el-table-column>
            <el-table-column
              prop="partnerNum"
              label="客户昵称"
            ></el-table-column>
            <el-table-column
              prop="partnerNum"
              label="客户电话"
            ></el-table-column>
            <el-table-column prop="userName" label="所属企业"></el-table-column>
            <el-table-column
              prop="partnerNum"
              label="所属分区"
            ></el-table-column> </template
        ></customTable>
      </template>
      <template v-else-if="selectActive === 4">
        <el-form
          class="mgt-10"
          ref="form"
          :model="form4"
          label-width="90px"
          inline
        >
          <el-form-item label="订单编号">
            <el-input
              v-model="form4.userName"
              placeholder="请输入订单编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="所属企业">
            <el-select
              v-model="form4.status"
              placeholder="请选择企业"
              clearable
              filterable
            >
              <el-option label="正常" :value="0"></el-option>
              <el-option label="冻结" :value="1"></el-option>
              <el-option label="锁定" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属分区">
            <el-select
              v-model="form4.status"
              placeholder="请选择分区"
              clearable
            >
              <el-option label="正常" :value="0"></el-option>
              <el-option label="冻结" :value="1"></el-option>
              <el-option label="锁定" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="水卡编号">
            <el-input
              v-model="form4.userName"
              placeholder="请输入水卡编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="客户电话">
            <el-input
              v-model="form4.userName"
              placeholder="请输入客户电话"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="充值方式">
            <el-select
              v-model="form4.status"
              placeholder="请选择充值方式"
              clearable
            >
              <el-option label="正常" :value="0"></el-option>
              <el-option label="冻结" :value="1"></el-option>
              <el-option label="锁定" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="充值日期">
            <el-date-picker
              v-model="form4.startTime"
              format="yyyy-MM-dd"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
            至
            <el-date-picker
              v-model="form4.endTime"
              :picker-options="pickerOptionsEnd"
              format="yyyy-MM-dd"
              type="date"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="search4">查 询 </el-button>
            <el-button @click="reset4">重 置 </el-button>
            <el-button type="primary" @click="exportTable">导出 </el-button>
          </el-form-item>
        </el-form>
        <customTable
          ref="customTable4"
          :api="undefined"
          :params="form"
          :isMounted="false"
        >
          <template #columns>
            <el-table-column
              type="index"
              :index="indexMethod"
              label="序号"
              width="50"
              fixed="left"
            >
            </el-table-column>
            <el-table-column
              prop="partnerNum"
              label="订单编号"
            ></el-table-column>
            <el-table-column prop="userName" label="所属企业"></el-table-column>
            <el-table-column
              prop="partnerNum"
              label="所属分区"
            ></el-table-column>
            <el-table-column prop="userName" label="水卡编号"></el-table-column>
            <el-table-column
              prop="partnerNum"
              label="客户电话"
            ></el-table-column>
            <el-table-column prop="userName" label="充值方式"></el-table-column>
            <el-table-column
              prop="partnerNum"
              label="充值时间"
            ></el-table-column>
            <el-table-column
              prop="userName"
              label="充值金额（元）"
            ></el-table-column>
            <el-table-column prop="userName" label="是否退款"></el-table-column>
            <el-table-column prop="userName" label="退款金额"></el-table-column>
            <el-table-column
              prop="userName"
              label="实际销售（元）"
            ></el-table-column></template
        ></customTable>
      </template>
    </el-card>
    <customModal
      ref="customerTransferModal"
      path="views/teamperformance/components/customerTransfer"
      center
      width="360px"
    >
    </customModal>
  </div>
</template>

<style scoped lang="scss">
::v-deep .el-card {
  height: 100% !important;
  width: 100% !important;
  padding: 0px !important ;
  .el-card__body {
    padding: 10px 20px;
  }
}
.selectBox {
  display: flex;
  margin-top: 20px;
  .select {
    margin-right: 50px;
    cursor: pointer;
    text-decoration: underline;
  }

  .selectActive {
    margin-right: 50px;
    cursor: pointer;
    text-decoration: underline;
    color: var(--accent);
  }
}
</style>
